import { useMemo } from 'react';

import type { ComponentId } from '@vgtv/api-client/lib/component';

import { useAppSelector } from '../../modules/hooks';
import { selectProfilesForComponent } from '../../modules/components';

export const useComponentProfiles = (id: ComponentId) => {
  const profiles = useAppSelector((state) =>
    selectProfilesForComponent(state, id)
  );
  const foundProfileIds = profiles.map(({ id }) => id).join(',');

  // deliberately skipping profiles in dependency list
  // eslint-disable-next-line react-hooks/exhaustive-deps
  return useMemo(() => profiles, [foundProfileIds]);
};
